import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resProfile {
  message: string;
  result: Profile;
  success: boolean;
}

interface Profile {
  DATE_OF_BIRTH: Date;
  EMAIL: string;
  GENDER: string;
  PERSONAL_DESCRIPTION: string;
  PHONENUMBER: string;
  PROFILE_PIC: string;
  ROLE: string;
  USERNAME: string;
  EXPERTIES: [{
    EXPERTIE_ID: number,
    EXPERTIE_NAME: string
  }]
  USER_ID: string;
  TYPE_REGISTER: number;
  IS_PREMIUM: boolean;
  COIN: number;
  PREMIUM_EXPIRE_DATE: Date;
  REGISTER_DATE: Date;
}

interface resExperties {
  success: boolean;
  message: string;
  result: [
    {
      EXPERTIE_ID: string;
      EXPERTIE_NAME: string;
    }
  ]
}

interface resGetDetailPremiumShop {
  success: boolean,
  message: string,
  result: {
    TOKEN_AVALABLE: number,
    DETAIL_EXCHANG: {
      TOKEN_REQ: number,
      PREMIUM_RECIVE: number,
      START_PREMIUM: Date,
      EXPIREDATE: Date
    }
  }
}

interface resGetAllAvatar {
  success: boolean,
  message: string,
  result: {
    IMAGE_NAME: string,
    IMAGE_URL: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  token: string = null;
  role: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);

    if (this.authService.getToken() !== '') {
      let _r = this.authService.getRole().subscribe(res => {
        this.role = res.result.ROLE;
        _r.unsubscribe();
      })
    }
  }

  getProfile() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resProfile>(environment.URL + '/authen/GetProfile', { headers: headers });
  }


  updateProfile(p) {
    let formData = new FormData();
    let date: any;
    if (p.dateOfBirth) {
      date = new Date(p.dateOfBirth);
    }

    const headers = new HttpHeaders({ Authorization: this.token })
    // user
    if (this.role === 'user') {
      formData.append('USERNAME', p.username);
      formData.append('GENDER', p.gender);
      formData.append('DATE_OF_BIRTH', date);
      if (p.profilePic !== '' || p.profilePic !== undefined) {
        formData.append('AVATA_PIC', p.profilePic);
      } else {
        formData.append('AVATA_PIC', '');
      }

      //admin
    } else if (this.role === 'admin') {
      formData.append('USERNAME', p.username);
      formData.append('GENDER', p.gender);
      formData.append('DATE_OF_BIRTH', date);
      formData.append('PHONENUMBER', p.phoneNO);
      formData.append('PERSONAL_DESCRIPTION', '');
      if (p.profilePic !== '') {
        formData.append('PROFILE_PIC', p.profilePic);
      }

      //teacher //psychologist
    } else if (this.role === 'teacher' || this.role === 'psychologist') {
      formData.append('USERNAME', p.username);
      formData.append('GENDER', p.gender);
      formData.append('DATE_OF_BIRTH', date);
      formData.append('PHONENUMBER', p.phoneNO);
      formData.append('EXPERTIES', p.experties);
      formData.append('PERSONAL_DESCRIPTION', p.description);
      if (p.profilePic !== '') {
        formData.append('PROFILE_PIC', p.profilePic);
      }
    }

    return this.http.post(environment.URL + '/authen/updateProfile', formData, { headers: headers });
  }


  getExpertie() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resExperties>(environment.URL + '/authen/getAllExperties', { headers });
  }

  changePassword(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    return this.http.post(environment.URL + '/authen/changPassword', body, { headers });

  }

  getDetailPremiumShop() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetDetailPremiumShop>(environment.URL + '/premium/getDetailPremiumShop', { headers });
  }

  upgradePremium() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/premium/upgradePremium', { body: {} }, { headers: headers });
  }

  getAllAvatar() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllAvatar>(environment.URL + '/authen/getAllAvatar', { headers });
  }
}
